import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=9bae35a4&scoped=true&"
import script from "./TableView.vue?vue&type=script&lang=ts&"
export * from "./TableView.vue?vue&type=script&lang=ts&"
import style0 from "./TableView.vue?vue&type=style&index=0&id=9bae35a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae35a4",
  null
  
)

export default component.exports